import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getResourceAvailableTags } from 'services/resources';

export interface IResourceAvailableTagsTag {
  uuid: string;
  name: string;
}

export interface IResourceAvailableTagsResponse {
  tags: IResourceAvailableTagsTag[];
}

export function useResourceAvailableTags(
  options?: Omit<
    UseQueryOptions<
      IResourceAvailableTagsResponse,
      Error,
      IResourceAvailableTagsResponse,
      QueryKey
    >,
    'queryKey'
  >
) {
  return useQuery<IResourceAvailableTagsResponse, Error>(
    `resource_available_tags`,
    () =>
      getResourceAvailableTags().then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message);
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
